import { render, staticRenderFns } from "./RelatedCategoryTags.vue?vue&type=template&id=3d98ef0a&scoped=true&"
import script from "./RelatedCategoryTags.vue?vue&type=script&lang=js&"
export * from "./RelatedCategoryTags.vue?vue&type=script&lang=js&"
import style0 from "./RelatedCategoryTags.vue?vue&type=style&index=0&id=3d98ef0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d98ef0a",
  null
  
)

export default component.exports